<template>
    <div>
        <div>
            <div class="n2-topbar">
                <div>
                    <div class="n2-topbar-content">
                        <a class="n2-topbar-sidebar-button n2-topbar-button" v-on:click="toogleNavVisible">
                            <div class="n2-topbar-icon">
                                <i aria-hidden="true" class="fa fa-bars"></i>
                            </div>
                        </a>
                        <h1 class="header-brand">
                            <a class="logo-link" v-bind:href="`/${app_locale}`" role="link">
                                {{ $t('header.title') }}
                            </a>
                        </h1>

                        <div style="flex: 1;"></div>
                        <div class="header-center">
                            <div class="header-login">
                                <template v-if="authenticated">
                                    <a v-bind:href="`/${app_locale}/account`" style="margin-right:10px;">{{
                                        $t('header.my_account') }}</a>
                                    <a href="#" v-on:click.prevent="signOut()">{{ $t('header.sign_out') }}</a>
                                </template>
                                <template v-else>
                                    <!-- <a v-bind:href="`/${app_locale}/signup`" style="margin-right:10px;">{{
                                        $t('header.sign_up') }}</a> -->
                                    <a onclick="document.getElementById('n1-signin-modal').style.display='block'">{{
                                        $t('header.sign_in') }}</a>

                                </template>
                            </div>
                            <div class="header-languages">
                                <div class="n2-dropdown-hover">
                                    <a href="#" v-on:click="changeLanguage()"> {{ the_other_language }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="n2-portal-main">
            <div class="n2-sidebar">
                <nav class="n2-sidebar-nav" v-bind:class="{ 'n2-sidebar-hidden': !nav_bar_visible }">
                    <div class="n2-sidebar-header">
                        <button class="n2-sidebar-item-link n2-sidebar-button n2-sidebar-humburger"
                            v-on:click="toogleNavVisible">
                            <div class="n2-sidebar-icon">
                                <i aria-hidden="true" class="fa fa-bars"></i>
                            </div>
                        </button>
                    </div>
                    <div class="n2-sidebar-middle">
                        <a class="n2-sidebar-item-link" v-bind:href="`/${app_locale}/admin/orders`"
                            v-if="checkMenuVisible('order')">
                            <div class="n2-sidebar-icon"></div>
                            <div class="n2-sidebar-label">
                                {{ $t('header.orders') }}
                            </div>
                        </a>
                        <a class="n2-sidebar-item-link" v-bind:href="`/${app_locale}/admin/contents`"
                            v-if="checkMenuVisible('content')">
                            <div class="n2-sidebar-icon"></div>
                            <div class="n2-sidebar-label">
                                {{ $t('header.contents') }}
                            </div>
                        </a>
                        <a class="n2-sidebar-item-link" v-bind:href="`/${app_locale}/admin/users`"
                            v-if="checkMenuVisible('user')">
                            <div class="n2-sidebar-icon"></div>
                            <div class="n2-sidebar-label">
                                {{ $t('header.users') }}
                            </div>
                        </a>
                        <a class="n2-sidebar-item-link" v-bind:href="`/${app_locale}/admin/roles`"
                            v-if="checkMenuVisible('role')">
                            <div class="n2-sidebar-icon"></div>
                            <div class="n2-sidebar-label">
                                {{ $t('header.roles') }}
                            </div>
                        </a>
                        <a class="n2-sidebar-item-link" v-bind:href="`/${app_locale}/admin/claims`"
                            v-if="checkMenuVisible('claim')">
                            <div class="n2-sidebar-icon"></div>
                            <div class="n2-sidebar-label">
                                {{ $t('header.claims') }}
                            </div>
                        </a>
                    </div>
                </nav>
            </div>
            <div style="width: 100%;">
                <template v-if="authorized">
                    <router-view />
                </template>
                <template v-else>
                    <unauthorized></unauthorized>
                </template>
            </div>
        </div>

        <div class="footer">
            <div class="container">
                <div style="min-height:100px;"></div>
            </div>
        </div>


        <div id="n1-signin-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="w3-container">
                    <signin></signin>
                </div>
            </div>
        </div>
        <div id="n1-unauthorized-modal" class="w3-modal" v-bind:class="{ 'n2-unauthorized-panel': unauthorized_panel_visible }">
            <div class="w3-modal-content w3-card-4" style="max-width:600px">
                <div class="w3-center">
                    <br>
                    <span v-on:click="closeUnauthorizedModal" class="w3-button w3-xlarge w3-hover-red w3-display-topright"
                        title="Close Modal">&times;</span>
                    <label class="n2-form-label">{{ $t('header.unauthorized') }}</label>
                </div>
                <div class="w3-container w3-padding-16">
                    <label>{{ $t('header.unauthorized_detail') }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Signin from '../components/app/signin.vue'
import Unauthorized from '../components/app/unauthorized.vue'


export default {
    name: 'MainLayout',
    components: {
        Unauthorized,
        Signin
    },
    data() {
        return {
            authorized: true
        }
    },
    computed: {
        ...mapGetters('identity', [
            'authenticated',
            'claims'
        ]),
        ...mapGetters('app_settings', [
            'nav_bar_visible',
            'unauthorized_panel_visible'
        ]),
        ...mapGetters('globalization', [
            'app_locale',
            'language',
            'languages'
        ]),
        the_other_language: function () {
            return this.app_locale == 'en' ? 'Norsk' : 'English'
        }
    },
    created: function () {
        this.$route.matched.forEach(record => {
            if (record.meta.claims && record.meta.claims.some(v => this.claims && !this.claims.map(cc => { return cc.claim_value }).includes(v))) {
                this.authorized = false;
            }

        });
    },
    mounted: async function () {
        await this.checkToken();


    },
    methods: {
        checkMenuVisible: function (claim) {
            return this.claims.some((element) => element.claim_value == claim)
        },
        toogleNavVisible: async function () {
            this.$store.commit('app_settings/set_nav_bar_visible', !this.nav_bar_visible);
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
        closeUnauthorizedModal: function () {
            this.$store.commit('app_settings/set_unauthorized_panel_visible', false);
        },
        changeLanguage() {
            let locale = this.app_locale == 'en' ? 'no' : 'en'
            if (locale !== this.$route.params.lang) {
                const to = this.$router.resolve({ params: { lang: locale }, query: this.$route.query })
                //this.$router.push(to.location)
                let p = to.location.path;
                if (p.length > 1 && p.slice(-1) == '/') {
                    p = p.substr(0, p.length - 1);
                }
                this.$router.push({ path: p, query: this.$route.query })
            }
        },
        checkToken: async function () {
            let authedUntil = await this.$store.dispatch('identity/get_authenticated_until');
            if (this.authenticated) {
                if (!authedUntil || new Date() > new Date(authedUntil)) {
                    await this.signOut();
                }
            }
            else if (authedUntil) {
                await this.signOut();
            }
        },
        signOut: async function () {
            try {
                await this.$store.dispatch('identity/signout');
                if (this.$route.path.split('/').some(a => a == 'account' || a == 'admin')) {
                    this.$router.push({
                        path: '/' + this.app_locale
                    });
                }
            }
            catch {
                this.model_errors = { sign_in: [this.$t('components.signin.error_sign_out')] }
            }
        }
    }
}
</script>
